import { COL_CRM_CLIENTS, COL_CRM_EVEREST_CLIENTS } from '../config/auth'
import { COL_PRODUCTION_REQUESTS } from '../config/collections'
import { pb } from '../pocketbase'
import { supabase } from './supabase'
import type { ProductionRequestRecord } from '../types/records'
import { extractCrmClientName } from './crmClients'

/**
 * Актуальное имя клиента из CRM по сохранённым полям заявки.
 * Не используется для режима manual и без подключённого CRM.
 */
export async function fetchFreshCrmClientNameForRequest(request: ProductionRequestRecord): Promise<string | null> {
  if (!supabase) return null
  const cc = request.clientCollection?.trim()
  const cid = request.clientRecordId?.trim()
  if (!cc || cc === 'manual' || !cid || cid === '-') return null
  if (cc !== COL_CRM_CLIENTS && cc !== COL_CRM_EVEREST_CLIENTS) return null

  try {
    const { data: rec } = await supabase.from(cc).select('id, name').eq('id', cid).single()
    if (!rec) return null
    return extractCrmClientName(rec)
  } catch {
    return null
  }
}

export type EnrichOptions = {
  /** Записать актуальное имя в коллекцию заявок СУП (если есть права). По умолчанию true. */
  persistToSupev?: boolean
}

/**
 * Если имя клиента в CRM изменилось — подставляет его в объект заявки и опционально сохраняет в PocketBase СУП.
 */
export async function enrichProductionRequestClientFromCrm(
  request: ProductionRequestRecord,
  options: EnrichOptions = {},
): Promise<ProductionRequestRecord> {
  const persist = options.persistToSupev !== false
  const fresh = await fetchFreshCrmClientNameForRequest(request)
  if (fresh == null || fresh === request.clientName) return request

  const merged = { ...request, clientName: fresh }
  if (!persist || !request.id) return merged

  try {
    await pb.collection(COL_PRODUCTION_REQUESTS).update(request.id, { clientName: fresh })
  } catch {
    /* только чтение или сеть — в интерфейсе всё равно показываем merged */
  }

  return merged
}

/** Параллельное обогащение списка заявок (список на странице). */
export async function enrichProductionRequestsClientNames(
  requests: ProductionRequestRecord[],
  options?: EnrichOptions,
): Promise<ProductionRequestRecord[]> {
  return Promise.all(requests.map((r) => enrichProductionRequestClientFromCrm(r, options)))
}
